import { compose, withState, withHandlers, getDisplayName } from 'recompose'

import Modal from '../components/Modal'

const modalWrapperFactory = (title, text, buttonText) => WrappedComponent => {
    const component = ({ isModalVisible, showModal, hideModal, onConfirm, ...props }) => (
        <div>
            <WrappedComponent {...props} showModal={showModal} />
            {isModalVisible && (
                <Modal
                    header={props.translate(title)}
                    buttons={[{ label: props.translate(buttonText), onClick: onConfirm }]}
                    onClose={hideModal}>
                    <T>{text}</T>
                </Modal>
            )}
        </div>
    )

    component.displayName = `withConfirmModal(${getDisplayName(WrappedComponent)})`

    return component
}

export const withConfirmModal = (
    title,
    text,
    buttonText,
    onConfirmHandler = () => {},
    showModalPropName = 'showModal',
    hideModalPropName = 'hideModal'
) =>
    compose(
        withState('isModalVisible', 'setIsModalVisible'),
        withHandlers({
            [showModalPropName]: props => () => props.setIsModalVisible(true),
            [hideModalPropName]: props => () => props.setIsModalVisible(false),
            onConfirm: props => () => {
                props.setIsModalVisible(false)
                onConfirmHandler(props)
            },
        }),
        withTranslate,
        modalWrapperFactory(title, text, buttonText)
    )
